import script from "./SessionExpired.vue?vue&type=script&setup=true&lang=ts"
export * from "./SessionExpired.vue?vue&type=script&setup=true&lang=ts"

import "./SessionExpired.vue?vue&type=style&index=0&id=2ebc6a9c&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ebc6a9c"]])

export default __exports__